import React, { useState } from 'react';
import { MAX_DURATION, MIN_DURATION } from '../data/presets';
interface DurationChipsProps {
  presets: number[];
  value: number;
  onSelect: (minutes: number) => void;
  idPrefix: string;
}
export function DurationChips({
  presets,
  value,
  onSelect,
  idPrefix
}: DurationChipsProps) {
  const [custom, setCustom] = useState('');
  const isPreset = presets.includes(value);
  const submitCustom = (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = Number.parseInt(custom, 10);
    if (!Number.isFinite(parsed)) return;
    const clamped = Math.min(MAX_DURATION, Math.max(MIN_DURATION, parsed));
    onSelect(clamped);
    setCustom('');
  };
  return <div data-id="element-34" data-mp="28z90akduanxu">
      <div className="flex flex-wrap gap-2" data-id="element-35" data-mp="28z0o6upjjmnp">
        {presets.map(minutes => {
        const active = minutes === value;
        return <button key={minutes} type="button" aria-pressed={active} onClick={() => onSelect(minutes)} className={`min-h-[44px] min-w-[60px] rounded-xl border px-3 text-sm font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral ${active ? 'border-coral bg-coral text-white' : 'border-line bg-surface text-ink hover:border-muted'}`} data-id="element-36" data-mp="sjfvnznxyo58">
              {minutes} min
            </button>;
      })}
        {!isPreset && <span className="flex min-h-[44px] items-center rounded-xl border border-coral bg-coral px-3 text-sm font-medium text-white" data-id="element-37" data-mp="3t66mrg9fppoe">
            {value} min
          </span>}
      </div>
      <form onSubmit={submitCustom} className="mt-3 flex items-center gap-2" data-id="element-38" data-mp="6pkayegz9f36">
        <label htmlFor={`${idPrefix}-custom`} className="sr-only" data-id="element-39" data-mp="kpbu0tmcplo1">
          Custom duration in minutes
        </label>
        <input id={`${idPrefix}-custom`} type="number" inputMode="numeric" min={MIN_DURATION} max={MAX_DURATION} value={custom} onChange={e => setCustom(e.target.value)} placeholder={`Custom (${MIN_DURATION}–${MAX_DURATION})`} className="min-h-[44px] flex-1 rounded-xl border border-line bg-bg px-3 text-sm text-ink placeholder:text-muted focus:border-muted focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-40" data-mp="got2l0odehmd" />
        <button type="submit" disabled={custom.trim() === ''} className="min-h-[44px] rounded-xl border border-line px-4 text-sm font-medium text-ink transition-colors duration-150 hover:bg-bg disabled:opacity-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-41" data-mp="1bg9bh4nou9s7">
          Set
        </button>
      </form>
    </div>;
}